import cleanAssign from "@/clean-assign";
import Decimal from "decimal.js";
import { reactive } from "vue";
import parseJson from "../parse-json";
import { BackendFetch } from "@hantera/portal-app";

export interface LegacyTagDefinition {
  number: Decimal
  name: string
}

const tags: {
  orderTags: LegacyTagDefinition[]
  deliveryTags: LegacyTagDefinition[]
  rmaTags: LegacyTagDefinition[]
} = reactive({
  orderTags: [],
  deliveryTags: [],
  rmaTags: [],
});

export default function (portalFetch: BackendFetch) {

  return {

    /**
     * A reactive object containing the tag definitions
     */
    value: tags,

    /**
     * Refreshes the tag definitions from server
     */
    async refresh() {

      const res = await portalFetch('/legacy-tag-definitions', {
        method: 'GET',
      });

      if (res.ok) {
        cleanAssign(tags, parseJson(await res.text()));
      }
    },

  };

}